module.exports = __webpack_public_path__ + "img/havefun_modelcourse_1_tc.a4601476.jpg";